<template>
    <section v-if="isAuthorized" class="hero2"></section>
  
    <section v-if="isAuthorized" class="gallery">
      <h2>GALERIE</h2>
      <div>
        <input type="file" @change="handleFileUpload" ref="fileInput" class="file-input">
        <button @click="submitFile" class="upload-btn">Télécharger l'Image</button>
      </div>
      <div class="gallery-grid">
        <div v-for="image in images" :key="image.src" class="image-container" style="margin-bottom: 20px;">
          <img :src="image.src" :alt="image.alt" @click="openModal(image.alt)">
          <button @click="deleteImage(image.alt)" class="delete-btn">Supprimer</button>
        </div>
      
      
      </div>

      <h2>Bannières de Sports</h2>
    <div class="sports-grid">
      <div v-for="sport in sportsTypes" :key="sport" class="sport-item">
        <h3>{{ sport }}</h3>
        <input type="file" class="upload-btn" @change="event => uploadBanner(sport, event.target.files[0])">
        <div class="banner-preview">
          <img :src="sportBanner(sport)" :alt="`Bannière pour ${sport}`">
        </div>
      </div>
    </div>
    </section>
    
   

    <div v-if="showModal" class="modal" @click="closeModal">
      <span class="close">&times;</span>
      <img :src="selectedImageSrc" :alt="selectedImageAlt" class="modal-content">
      <div id="caption">{{ selectedImageAlt }}</div>
    </div>
  
    <div v-if="!isAuthorized">
      <p>Accès non autorisé.</p>
    </div>
  </template>
  
  
  <script>
  import { ref, onMounted } from 'vue';
  import axios from 'axios';
  import { useStore } from 'vuex';
  import { sportBanner, sportBannerName } from '@/api/base';
  import { useRouter } from 'vue-router';
  
  export default {
    setup() {
      const store = useStore();
      const router = useRouter();
      const images = ref([]);
      const showModal = ref(false);
      const selectedImageSrc = ref('');
      const selectedImageAlt = ref('');
      const isAuthorized = ref(false);
      const sportsTypes = ref([]); 
      const banners = ref({});

      const userId = store.state.auth.user.data.id;
  
      onMounted(async () => {
        if (userId === 2438) {
          isAuthorized.value = true;
          await fetchImages();
        } else {
          router.push({ name: 'HomePage' });
        }
      });
  
      async function fetchImages() {
        try {
          const response = await axios.get('/api/gallery/images');

          images.value = response.data
            .filter(filename => !filename.startsWith('banner_'))
            .map(filename => ({
              src: `https://www.ouicsport.fr/api/gallery_img/${filename}`,
              alt: `${filename}`
            }));
            
        } catch (error) {
          console.error("Erreur lors de la récupération des images :", error);
        }
      }

      async function fetchSportsTypes() {
      try {
        const response = await axios.get('https://www.ouicsport.fr/api/profile/sports-types-list');
        sportsTypes.value = response.data.sports; 
       
      } catch (error) {
        console.error("Erreur lors de la récupération des types de sports :", error);
      }
    }
    fetchSportsTypes();

    async function uploadBanner(sport, file) {
      const formData = new FormData();
      formData.append('image', file);
      formData.append('typeDeSport', sport);

      try {
        const response = await axios.post('/api/gallery/uploadBanner', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        response;
        const fileName = sportBannerName(sport);

        images.value.push({
          src: `https://www.ouicsport.fr/api/gallery_img/${fileName}`, 
          alt: `Bannière pour ${sport}`,
          filename: fileName, 
        });

        await fetchImages(); 
      } catch (error) {
        console.error(`Erreur lors de l'upload de l'image de la bannière pour ${sport}:`, error);
      }
    }
    
      function openModal(image) {
        showModal.value = true;
        selectedImageSrc.value = image.src;
        selectedImageAlt.value = image.alt;
      }
  
      function closeModal() {
        showModal.value = false;
      }
  
      return {
        images,
        showModal,
        selectedImageSrc,
        selectedImageAlt,
        openModal,
        closeModal,
        isAuthorized,
        sportsTypes,
        uploadBanner,
        banners,
        sportBanner
      };
    },
    methods: {
    handleFileUpload(event) {
      this.file = event.target.files[0];
    },
    async submitFile() {
      if (!this.file) return;
      const formData = new FormData();
      formData.append('image', this.file);
      try {
        const response = await axios.post('/api/gallery/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        this.images.push({
          src: `https://www.ouicsport.fr/api/gallery_img/${response.data.filename}`,
          alt: `Image ${response.data.filename}`,
          filename: response.data.filename, 
        });
        this.$refs.fileInput.value = ''; 
        window.location.reload(true);
      } catch (error) {
        console.error("Erreur lors de l'upload de l'image :", error);
      }
    },


    async deleteImage(filename) {
      try {
        await axios.delete(`/api/gallery/delete/${filename}`);
        this.images = this.images.filter(image => image.filename !== filename);
        window.location.reload(true);
      } catch (error) {
        console.error("Erreur lors de la suppression de l'image :", error);
      }
    },
  },
  };
  </script>
  
  <style scoped>
  </style>
  